import * as React from 'react';
import Rheostat, { Props as RheostatProps } from 'rheostat-yandex-direct';

import { Bem } from '../../service/Bem/Bem';

import './Slider.css';

export enum SliderTheme {
    success = 'success',
    warning = 'warning',
    error = 'error',
    intervalToggle = 'interval-toggle'
}

export enum SliderSize {
    xs = 'xs',
    n = 'n'
}

interface SliderProps extends RheostatProps {
    theme?: SliderTheme;
    size?: SliderSize;
}

export class Slider extends React.PureComponent<SliderProps> {
    render() {
        const { theme = 'success', disabled, size = SliderSize.n } = this.props;

        return (
            <Rheostat
                {...this.props}
                className={Bem.cls({
                    block: 'slider',
                    mods: {
                        theme: theme,
                        disabled: Boolean(disabled),
                        size: size
                    }
                })}
            />
        );
    }
}
